import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthConfigUi } from 'src/app/utils/authConfig';
import { AuthConfigService } from 'src/service/auth-config.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { AuthConfigType, FileUploadFor, GalleryType, InteractionType, LocalService, PageKey, Status } from 'src/service/local.service';

@Component({
  selector: 'app-auth-configs',
  templateUrl: './auth-configs.component.html',
  styleUrl: './auth-configs.component.scss'
})
export class AuthConfigsComponent {
  AuthConfigType = AuthConfigType; FileUploadFor = FileUploadFor; GalleryType = GalleryType;
  lstSectionConfigKeys: string[] = ["auth_config", "table"]; maxBodyHeight = 0;
  businessId: string = ''; ctryCode: string = ''; interactionType = 0; sampleParentId: string = '000000000000000000000000';

  authConfigUi: AuthConfigUi; authConfigType: AuthConfigType = AuthConfigType.BunnyStorage;

  isOtpVerified = false; isOpenSampleFileUpload = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private authConfigService: AuthConfigService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;

      this.configurationManagementService.ensurePageActions(PageKey.AuthConfig);

      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId, false, this.interactionType == InteractionType.User ? routeParams.businessId : '');
        this.ctryCode = routeParams.ctryCode;
        this.businessId = routeParams.businessId ? routeParams.businessId : '';
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onLoad();
  }

  onLoad() {
    this.isOpenSampleFileUpload = false;
    this.authConfigService.getAuthConfig(this.businessId, this.authConfigType).subscribe(result => {
      this.authConfigUi = result;
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onSaveConfig();
      } break;
      case 2: {
        this.isOpenSampleFileUpload = true;
      } break;
      case 3: {
        this.localService.galleryViewUrl = [this.authConfigUi.viewUrl];
      } break;
    }
  }

  onVerifiedOtp(e: any) {
    this.isOtpVerified = true;
    this.onInitiate();
  }

  onSaveConfig() {
    this.authConfigService.saveAuthConfig(this.businessId, this.authConfigType, this.authConfigUi).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
